import React from 'react';
import { useKatalFeatureFlag } from 'libs/hooks';
import MilestonesAntd from './component-antd';
import MilestonesKatal from './component-katal';

const Milestones = (props: any) => {
  const useKatal = useKatalFeatureFlag();

  return useKatal ? (
    <MilestonesKatal {...props} />
  ) : (
    <MilestonesAntd {...props} />
  );
};

export default Milestones;
